:host{display:flex;height:100vh;overflow:hidden}.content{flex:1;overflow:auto}
/*# sourceMappingURL=shell.layout-LJOS37UR.css.map */
